import { GET_CARPENTER, REQUEST_CARPENTER } from '../actions/Types'

const getCarpenter = (state={loading: false, data: []}, action) => {
    if (action.type === GET_CARPENTER){
        return {loading: false, data: action.payload}
    }
    else if (action.type === REQUEST_CARPENTER){
        return {loading: true, data: []}
    }
    return state
}

export default getCarpenter